import { TableHeader } from "@tiptap/extension-table";
import { renderIconInCell } from "./firstColumnIcon";

export const ReadOnlyTableHeader = TableHeader.extend({
  addAttributes() {
    return {
      ...this.parent?.()
      // any custom attributes
    };
  },

  addNodeView() {
    return ({ node, HTMLAttributes }) => {
      const dom = document.createElement("th");
      Object.entries(HTMLAttributes).forEach(([key, value]) => {
        dom.setAttribute(key, value);
      });
      dom.contentEditable = "false";

      if (renderIconInCell(dom, node.textContent, true)) {
        return { dom };
      }

      const contentDOM = document.createElement("div");
      dom.appendChild(contentDOM);
      return { dom, contentDOM };
    };
  }
});
